import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const TreeTableCard = styled.div`
    color: ${colors.greyscale.darker_grey};
    font-size: 16px;

    .p-treetable .p-treetable-thead > tr > th {
        background: white;
        font-size: 14px;
        color: ${colors.greyscale.darker_grey};
        padding: 0.2rem 2rem;
        font-weight: bold;
        outline-width: 5px;
    }

    .p-treetable .p-treetable-thead .pi {
        font-size: 12px;
    }

    .p-treetable .p-treetable-tbody > tr {
        background: ${colors.mainColors.white_lilac};
        margin-bottom: 5px;
        cursor: default;
    }

    .p-treetable .p-treetable-tbody > tr > td {
        border: 2px solid white;
        padding: 0.1rem 1rem;
    }

    .p-treetable .p-treetable-tbody .pi {
        font-weight: bold;
    }

    .p-inactivate{
        color: ${colors.greyscale.grey} !important;

        .btn-link{
            color: ${colors.greyscale.grey} !important;
        }
    }

    .sm-visible {
        display: table-cell;
    }

    
    
    @media screen and (max-width: 40em) {
        .sm-invisible {
            display: none;
        }

        .sm-text{
            width: 60% !important;
        }

        .sm-actions{
            width: 10% !important;
        }
    
        .sm-visible {
            display: none;
            margin-right: .5rem;
        }
    }
`